const getRuntimeConfig = () => {
  if (typeof window === "undefined") {
    return {};
  }

  return window.__ENV__ || {};
};

const runtimeConfig = getRuntimeConfig();

const getConfiguredBaseUrl = () => {
  const apiBaseUrl = (runtimeConfig.apiBaseUrl || "").trim();
  const baseUrl = (runtimeConfig.BASE_URL || "").trim();

  return apiBaseUrl || baseUrl || "";
};

const configuredBaseUrl = getConfiguredBaseUrl();

const appConfig = {
  apiBaseUrl: configuredBaseUrl,
  baseUrl: configuredBaseUrl,
  signatureSecret: runtimeConfig.TAGROS_SIGNATURE_KEY || runtimeConfig.SIGNATURE_SECRET || "",
};

export default appConfig;
